'use client';

import type { TrailId } from '@alltrails/types/TrailId';
import ScrollLimit from '@alltrails/user-auth/components/ScrollLimit/ScrollLimit';
import DismissibleScrollWall from './DismissibleScrollWall';

type Props = {
  hasReachedPageLimit: boolean;
  trailId: TrailId;
};

export default function DismissibleWallTreatment({ hasReachedPageLimit, trailId }: Props) {
  if (hasReachedPageLimit) {
    return <ScrollLimit deeplinkData={{ pageId: trailId, pageType: 'trail' }} />;
  }

  return <DismissibleScrollWall trailId={trailId} />;
}
